import * as Sentry from '@sentry/react';

export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || '0.1.0-beta',
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error', 'warn']
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],
    beforeSend(event) {
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.filter(breadcrumb => {
          if (breadcrumb.data?.url && breadcrumb.data.url.includes('/api/backup')) {
            return false;
          }
          if (breadcrumb.message) {
            const message = breadcrumb.message.toLowerCase();
            if (message.includes('/api/backup')) return false;

            // Strip financial data patterns and names
            breadcrumb.message = breadcrumb.message
              .replace(/\$\d+(\.\d{2})?/g, '[REDACTED_AMOUNT]')
              .replace(/(MYR|RM)\s*\d+(\.\d{2})?/gi, '[REDACTED_AMOUNT]')
              .replace(/(fund|group)\s+name:\s+[\w\s]+/gi, '[REDACTED_NAME]');
          }
          return true;
        });
      }
      return event;
    },
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'console' && breadcrumb.message) {
        const msg = breadcrumb.message.toLowerCase();
        if (
          msg.includes('balance') ||
          msg.includes('amount') ||
          msg.includes('myr') ||
          msg.includes('rm') ||
          msg.includes('$') ||
          msg.includes('fund') ||
          msg.includes('group')
        ) {
          breadcrumb.message = '[REDACTED_CONSOLE_LOG]';
        }
      }
      return breadcrumb;
    }
  });
}
